import Cookies from 'js-cookie';
import { EXP_LOGIN_ROLE_COOKIE_NAME, USER_EXPIRE_DAYS } from 'constants/cookies';
import { isDevelopment } from 'utils/environment';

/**
 * Role chosen on the eXp Realty US login role-selection screen (state 0).
 * Persisted for analytics + downstream routing decisions.
 */
export enum ExpLoginRole {
  AGENT = 'agent',
  BUYER_OR_SELLER = 'buyer_or_seller',
  OTHER = 'other',
}

/**
 * Persists the selected login role in the `exp_login_role` cookie.
 * Follows the codebase cookie conventions:
 * - expires: USER_EXPIRE_DAYS (183 days) — matches the user-identity cookie lifespan
 * - secure: true in production, false in development
 * - sameSite: 'lax'
 */
export function setExpLoginRoleCookie(role: ExpLoginRole): void {
  Cookies.set(EXP_LOGIN_ROLE_COOKIE_NAME, role, {
    expires: USER_EXPIRE_DAYS,
    secure: !isDevelopment,
    sameSite: 'lax',
    path: '/',
  });
}
